import { useGeneralStore } from "%/stores/general-store";
import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useOrgStoryWithVariantsFeedStore = defineSmartFeedPiniaStore("org-story-with-variants-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      lastId: Number.MAX_SAFE_INTEGER,
      orgId: useGeneralStore().orgId,
    },
    tableFields: [
      { key: "title", label: "Title", verticalAlign: "top" },
      { key: "destination", label: "Destination" },
      { key: "views", label: "Views" },
      { key: "engagements", label: "Engagements" },
      { key: "revenue", label: "Revenue" },
      { key: "status", label: "Status" },
      { key: "edited", label: "Edited" },
      { key: "actions", label: "", verticalAlign: "top" },
    ],
  }),
  getters: {
    feedUrl() {
      return `/org/${this.metadata.orgId}/story/variants/smart-feed`;
    },
  },
});
